import { useContext } from 'react'

import { Form as FormProvider } from 'components/Form'
import { DefaultsPageContext } from 'features/globalSetup/contexts/DefaultsPageContext'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { Form } from './Form'
import { useUpdateWorkspacePrebidConfiguration } from './hooks/useUpdateWorkspacePrebidConfiguration'
import { Schema, schema, schemaDefault } from './schema'

export const FormContainer = (): JSX.Element => {
  const {
    formId,
    loading,
    prebid: { workspaceConfig },
    setTouched,
    setValid,
  } = useContext(DefaultsPageContext)
  const { workspaceId } = useWorkspaceParam()
  const { errors: apiErrors, update } = useUpdateWorkspacePrebidConfiguration()

  if (!workspaceConfig) {
    throw Error('workspaceConfig should exists at this point')
  }

  return (
    <FormProvider<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(workspaceConfig, workspaceId)}
    >
      {() => <Form />}
    </FormProvider>
  )
}
